export default class {
  /**
   * 重置页码为1，并获取新的可能带有筛选条件的数据，外部筛选、重置时调用
   */
  resetAll () {
    if (this.page) {
      if (this.customPage === 1) {
        this.methods('getData')
      } else {
        this.customPage = 1
        this.methods('getData')
      }
    } else {
      this.methods('getData')
    }
  }
  /**
   * 更改排序字段，重置并获取
   * @param sort
   */
  sortChange (sort) {
    // 清空tableSort先
    for (let item in this.tableSort) {
      this.tableSort[item] = undefined
    }
    // 设置选择的升序/降序字段
    this.tableSort[sort.order] = sort.prop
    // 重新触发获取数据
    this.methods('resetAll')
  }
  /**
   * 触发父组件上的获取数据方法
   */
  getData () {
    this.$nextTick(() => {
      this.$emit('getData', {pageSize: this.customPageSize, page: this.customPage}, this.tableSort)
    })
  }
  /**
   * 向上触发各类表格点击事件
   */
  emitEvent (name, data) {
    this.$emit(name, data)
  }
  /**
   * 设置分页的size，表格默认条数
   */
  /*setPageSize () {
    let height = $(this.$refs.cTablePage).height()
    console.log(height)
    // 90:表格头的高度 + 底部分页的高度
    let size = parseInt((height - 90) / 48)
    this.customPageSize = size
    this.defaultPageSize = size
    if (this.tableData.length > 0) {
      console.log(this.tableData)
      let temp = this.tableData.slice(0, size)
      console.log(temp, 'temp')
      this.data = temp
      // 整个表格的高度
      this.tableHeight = height - 45
    }
  }*/
}
